// src/services/accountRegistry.ts
// このブラウザでログインしたことのあるアカウント一覧（Xのようなアカウント切替機能用）。
// 実際のトークン（idToken/accessToken/refreshToken）は amazon-cognito-identity-js が
// ユーザー名ごとに localStorage へ保存済み（CognitoIdentityServiceProvider.<clientId>.<username>.*）
// なので、ここでは「どのアカウントが存在するか」「最後にいつログイン/切替したか」だけを持つ。

export interface LoggedInAccountInfo {
  sub: string;
  username: string;
  lastLoginAt: number;
}

const STORAGE_KEY = 'rl_logged_in_accounts';

function readAll(): LoggedInAccountInfo[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(accounts: LoggedInAccountInfo[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(accounts));
}

/** ログインが新しい順（降順）で返す */
export function getLoggedInAccounts(): LoggedInAccountInfo[] {
  return readAll().sort((a, b) => b.lastLoginAt - a.lastLoginAt);
}

/** ログイン・切替が成功するたびに呼ぶ。既存なら最終ログイン日時を更新、無ければ追加する */
export function touchLoggedInAccount(sub: string, username: string): void {
  const accounts = readAll();
  const idx = accounts.findIndex((a) => a.sub === sub);
  const now = Date.now();
  if (idx >= 0) {
    accounts[idx] = { ...accounts[idx], username, lastLoginAt: now };
  } else {
    accounts.push({ sub, username, lastLoginAt: now });
  }
  writeAll(accounts);
}

/** ログアウト、またはトークン失効が確認できたアカウントを一覧から取り除く */
export function removeLoggedInAccount(sub: string): void {
  writeAll(readAll().filter((a) => a.sub !== sub));
}
